import { toast } from 'react-toastify';
import store from '../redux/store';
import { logOut } from '../redux/auth/actions';

// Inactivity timeout in milliseconds (15 minutes)
const INACTIVITY_TIMEOUT = 15 * 60 * 1000;
// Interval for updating the countdown (every second)
const COUNTDOWN_INTERVAL = 1000;

let inactivityTimer;
let countdownInterval;
let remainingTime = INACTIVITY_TIMEOUT;

// Format time in MM:SS format
// const formatTime = (milliseconds) => {
//   const totalSeconds = Math.floor(milliseconds / 1000);
//   const minutes = Math.floor(totalSeconds / 60);
//   const seconds = totalSeconds % 60;
//   return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
// };

// Reset the timer whenever there's user activity
const resetTimer = () => {
  if (inactivityTimer) {
    clearTimeout(inactivityTimer);
  }
  
  // Clear the countdown interval
  if (countdownInterval) {
    clearInterval(countdownInterval);
  }
  
  // Reset remaining time
  remainingTime = INACTIVITY_TIMEOUT;
  
  // Check if user is authenticated before setting a new timer
  const state = store.getState();
  if (state.auth.isAuthenticated) {
    // Start the countdown timer
    countdownInterval = setInterval(() => {
      remainingTime -= COUNTDOWN_INTERVAL;
      // console.log(`Auto-logout in: ${formatTime(remainingTime)}`);
      
      if (remainingTime <= 0) {
        clearInterval(countdownInterval);
      }
    }, COUNTDOWN_INTERVAL);
    
    // Set the inactivity timer
    inactivityTimer = setTimeout(() => {
      // Log out the user after inactivity period
      store.dispatch(logOut());
      
      // Show a toast notification instead of an alert
      toast.info('You have been logged out due to inactivity.', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      
      // Clear the countdown interval
      if (countdownInterval) {
        clearInterval(countdownInterval);
      }
    }, INACTIVITY_TIMEOUT);
  }
};

// Function to setup the inactivity timer
export const setupInactivityTimer = () => {
  // Events that indicate user activity
  const activityEvents = [
    'mousedown',
    'mousemove',
    'keypress',
    'scroll',
    'touchstart',
    'click',
  ];
  
  // Add event listeners for user activity
  activityEvents.forEach(event => {
    window.addEventListener(event, resetTimer);
  });
  
  // Initialize timer
  resetTimer();
  console.log('Inactivity timer started. Auto-logout will occur after inactivity.');
};

// Function to clear the inactivity timer
export const clearInactivityTimer = () => {
  if (inactivityTimer) {
    clearTimeout(inactivityTimer);
  }
  
  // Clear the countdown interval
  if (countdownInterval) {
    clearInterval(countdownInterval);
  }
  
  // Remove event listeners to prevent memory leaks
  const activityEvents = [
    'mousedown',
    'mousemove',
    'keypress',
    'scroll',
    'touchstart',
    'click',
  ];
  
  activityEvents.forEach(event => {
    window.removeEventListener(event, resetTimer);
  });
  
  console.log('Inactivity timer cleared.');
}; 